import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "../../userLayout.scss";

import UserProfile from "../../../../assets/images/user-profile.png";

import { ReactComponent as NotificationICon } from "../../../../assets/images/notification-new.svg";
import { ReactComponent as UserLocation } from "../../../../assets/images/user-location.svg";
import { ReactComponent as Tour } from "../../../../assets/images/dashboard-icons/tour.svg";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationList } from "../../../../redux/slices/notificationSlice";
import { getViewProfile } from "../../../../redux/slices/profileSlice";
import { getProfileCompletionPercent } from "../../../../utils/profileCompletion";
import { startTour } from "../../../../components/tour/tourBus";
import ThemeToggle from "./ThemeToggle";
import {
  PlanShield,
  UpgradePlanModal,
} from "../../../../components/subscription/UpgradePlanModal";

// Resolve the guided-tour pageKey for the current route (and, on the
// salaries/paycheck page, the active tab via the ?tab param). Returns null
// on routes without a tour, which hides the replay button.
const resolveTourKey = (pathname, search) => {
  if (pathname === "/dashboard") return "dashboard";
  if (pathname === "/mortgage") return "mortgage";
  if (pathname === "/comparison") return "comparison";
  if (pathname === "/jobs") return "jobs";
  if (pathname.startsWith("/job-detail/")) return "job-detail";
  if (pathname === "/search") return "search";
  if (pathname.startsWith("/search/details/")) return "search-detail";
  if (pathname === "/community") return "community";
  if (pathname === "/profile") return "profile";
  if (pathname === "/profile/subscription") return "subscription";
  if (pathname === "/contact-us") return "contact";
  if (pathname === "/blog") return "blog";
  if (pathname.startsWith("/blog/")) return "blog-detail";
  if (pathname === "/messaging" || pathname.startsWith("/messaging/"))
    return "messaging";
  if (pathname === "/salaries-paychecks") {
    const tab = new URLSearchParams(search).get("tab");
    return tab === "paycheck" || tab === "tax" ? "paycheck" : "salaries";
  }
  return null;
};

const HeaderDashboard = ({ toggleMobileMenu, mobileMenuOpen }) => {
  const store = useSelector((state) => state.profile);
  const authStore = useSelector((state) => state.auth);
  const location = useLocation();
  const [unreadData, setUnreadData] = useState([]);
  const profileCompletionPercent = getProfileCompletionPercent(
    store?.profileItem?.data,
  );

  const dispatch = useDispatch();

  const _fetchNotification = async () => {
    try {
      let obj = {
        page: 1,
        length: 10,
      };
      const result = await dispatch(getNotificationList(obj));
      const newData = result?.payload?.data?.count?.unread;
      const success = result?.payload?.success;

      if (success) {
        setUnreadData(newData);
      } else {
        console.warn("Fetch failed:", result?.payload?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(getViewProfile());
  }, []);
  useEffect(() => {
    _fetchNotification();
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    if (mobileMenuOpen) {
      html.classList.add("body-mobile-menu-open");
    } else {
      html.classList.remove("body-mobile-menu-open");
    }
    // Cleanup for when component unmounts
    return () => {
      html.classList.remove("body-mobile-menu-open");
    };
  }, [mobileMenuOpen]);

  const emptyData = () => {
    setUnreadData("");
  };

  // Plan shield next to the logged-in user's name — tapping it opens the
  // shared upgrade modal.
  const [showUpgrade, setShowUpgrade] = useState(false);

  return (
    <>

    <header className="header">
      <div className="header-info">
        {/* Hamburger menu button for mobile */}
        <button
          className="hamburger-menu d-lg-none"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span
            className={`hamburger-line ${mobileMenuOpen ? "active" : ""}`}
          ></span>
          <span
            className={`hamburger-line ${mobileMenuOpen ? "active" : ""}`}
          ></span>
          <span
            className={`hamburger-line ${mobileMenuOpen ? "active" : ""}`}
          ></span>
        </button>
        <div className="user-info">
          {resolveTourKey(location.pathname, location.search) && (
            <button
              type="button"
              className="replay-tour-btn"
              aria-label="Replay page tutorial"
              title="Replay tutorial"
              onClick={() =>
                startTour(resolveTourKey(location.pathname, location.search))
              }
            >
              <Tour />
            </button>
          )}
          <ThemeToggle />
          <NavLink
            to="/notification"
            className="notification"
            onClick={emptyData}
          >
            <NotificationICon />
            {unreadData > 0 && (
              <span>{unreadData > 99 ? "99+" : unreadData}</span>
            )}
          </NavLink>
          <NavLink
            to="/profile"
            className="d-flex align-items-center text-decoration-none"
          >
            <div className="d-none d-sm-block">
              {/* Plan badge + upgrade-modal click commented out per request
              <div
                className="user-name"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  // Inside a NavLink to /profile — block navigation.
                  e.preventDefault();
                  setShowUpgrade(true);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setShowUpgrade(true);
                  }
                }}
                style={{ cursor: "pointer" }}
                title="View upgrade options"
              >
                {authStore?.user?.full_name}
                <PlanShield
                  planName={authStore?.user?.plan?.name}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowUpgrade(true);
                  }}
                />
              </div>
              */}
              <div className="user-name">
                {authStore?.user?.full_name}
              </div>
              <div className="user-address">
                {authStore?.user?.city ? (
                  <>
                    <UserLocation />
                    <span>
                      {authStore?.user?.city},
                      {/* {authStore?.user?.filter_preference?.states[0]
                    ? authStore?.user?.filter_preference?.states[0]
                    : authStore?.user?.living_state} */}
                      {authStore?.user?.living_state}
                    </span>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="user-avtar-wrap">
              <div className="user-avtar">
                <img
                // src={
                //   authStore?.user?.profile_photo_path
                //     ? `${process.env.REACT_APP_API_BASE_URL}/${authStore?.user?.profile_photo_path}`
                //     : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                //       authStore?.user?.full_name || "User"
                //     )}&background=0195D3&color=fff&size=100`
                // }
                src={
                  authStore?.user?.profile_photo_path
                    ? `${process.env.REACT_APP_API_BASE_URL}/${
                        authStore.user.profile_photo_path.startsWith(
                          "uploads/user_profile/",
                        )
                          ? authStore.user.profile_photo_path
                          : `uploads/user_profile/${authStore.user.profile_photo_path}`
                      }`
                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        authStore?.user?.full_name || "User",
                      )}&background=0195D3&color=fff&size=100`
                }
                alt="User Profile"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    authStore?.user?.full_name || "User",
                  )}&background=0195D3&color=fff&size=100`;
                }}
              />
              </div>
              {profileCompletionPercent < 100 && (
                <span
                  className="user-avtar-completion-badge"
                  title={`Profile ${profileCompletionPercent}% complete`}
                >
                  {profileCompletionPercent}%
                </span>
              )}
            </div>
          </NavLink>
        </div>
      </div>
      </header>
      {/* Upgrade modal commented out per request
      <UpgradePlanModal
        show={showUpgrade}
        onClose={() => setShowUpgrade(false)}
        source="header_plan_badge"
      />
      */}
    </>
  );
};

export default HeaderDashboard;
